module.exports = __webpack_public_path__ + "static/img/bg3.f0d5f024.webp";